import * as React from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import styled from 'styled-components';
import { CheckObjectValue } from 'types/common';
import { LegacyPaymentStatus } from 'types/plansales/billing';
import { legacyPaymentStatusLabel } from 'constants/plansales/billing';

interface Props {
  payStatus: CheckObjectValue;
  onChangePayStatus: (
    status: LegacyPaymentStatus,
  ) => (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const LegacyPayStatusFilters = ({ payStatus, onChangePayStatus }: Props) => {
  const payStatusCheckboxes: LegacyPaymentStatus[] = [
    LegacyPaymentStatus.SUCCESS,
    LegacyPaymentStatus.REFUND,
    LegacyPaymentStatus.TRIED_YET,
    LegacyPaymentStatus.VOID,
  ];
  return (
    <>
      {payStatusCheckboxes.map(status => (
        <FormControlLabel
          key={status}
          control={
            <Checkbox
              value={status}
              color={'primary'}
              checked={payStatus[status]}
              onChange={onChangePayStatus(status)}
            />
          }
          label={<LabelText>{legacyPaymentStatusLabel[status]}</LabelText>}
        />
      ))}
    </>
  );
};

export default LegacyPayStatusFilters;

export const LabelText = styled.span`
  text-transform: capitalize;
`;
